import { Box } from '@primer/react';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ClubRegistrationHistory from './ClubRegistrationHistory';
import ClbNgoaiKhoaNavigation from './ClubRegistrationNavigation';
import ClubRegistrationPage from './ClubRegistrationPage';
import ClubPeriodPage from '../club/ClubPeriodPage';

const ClubRegistrationLayout = () => {
    const { tab } = useParams();
    const navigate = useNavigate();
    const selectedTab = useMemo(() => {
        if (tab === "ket-qua") {
            return "ket-qua";
        }
        if (tab === "period") {
            return "period";
        }
        return "clb";
    }, [tab])
    return (
        <Box sx={{
            p: 3,
            pt: 2
        }}>
            <Box sx={{ mb: 2 }}>
                <ClbNgoaiKhoaNavigation
                    selectedTab={selectedTab}
                    onSelectedChanged={(tab) => {
                        navigate("../../club-registration/" + tab);
                    }}
                />
            </Box>
            {selectedTab === "period" &&
                <ClubPeriodPage />
            }
            {selectedTab === "clb" &&
                <ClubRegistrationPage />
            }
            {selectedTab === "ket-qua" &&
                <ClubRegistrationHistory />
            }
        </Box>
    );
};

export default ClubRegistrationLayout;